<template>
  <section
    class="section section-shaped section-lg min-h-screen flex items-center justify-center"
  >
    <div class="max-w-screen-sm md:w-1/2">
      <div class="card shadow-sm rounded-3xl mt-24 mb-4">
        <div class="flex flex-row-reverse">
          <div @click="route" class="go-back">
            <Close class="text-dark" />
          </div>
          <div class="logo"></div>
        </div>

        <div class="card-body px-lg-5 pt-lg-2">
          <p class="mx-auto my-4">
            Registrarte, aprende y especialízate en las diversas áreas de la
            medicina a tan solo un clic
          </p>

          <form @submit.prevent="login_form">
            <div class="flex flex-justify-between">
              <CustomInput
                type="text"
                identity="name"
                ref="name"
                label="Nombres"
                placeholder="Nombres"
                v-model="user.name"
                :rules="{
                  required: true,
                }"
                class="mr-2"
              />
              <CustomInput
                type="text"
                identity="name"
                ref="lname"
                label="Apellidos"
                placeholder="Apellidos"
                class="ml-2"
                v-model="user.lname"
                :rules="{
                  required: true,
                }"
              />
            </div>
            <CustomInput
              identity="email"
              ref="email"
              type="email"
              label="Correo electrónico"
              placeholder="Correo electrónico"
              v-model="user.email"
              :rules="{
                required: true,
                email: true,
              }"
            />
            <CustomInput
              :password="true"
              v-model="user.password"
              type="password"
              ref="password"
              identity="Contraseña"
              placeholder="contraseña"
              label="Contraseña"
              :rules="{
                required: true,
              }"
            />
            <div class="form-group mb-3">
              <div class="input-group input-group-alternative">
                <vue-phone-number-input
                  v-model="user.movil"
                  :default-country-code="defaultCountry"
                  :only-countries="countriesList"
                  :translations="translations"
                  @update="onUpdate"
                  aria-required="true"
                  color="null"
                >
                </vue-phone-number-input>
              </div>
              <p
                v-if="serverErrors"
                class="text-danger"
                style="font-size: 1rem"
              >
                {{ serverErrors.password }}
              </p>
            </div>

            <p
              class="my-4"
              style="color: #000; font-weight: 400; font-size: 13px"
            >
              ¿Cual es tu fecha de nacimiento?
            </p>

            <div class="date-picker mb-4">
              <div class="custom-select">
                <i class="fas fa-chevron-up" style="top: 9px"></i>
                <i class="fas fa-chevron-down" style="bottom: 7px"></i>
                <select required v-model="selected_day">
                  <option value="0" disabled selected>Día</option>
                  <option v-for="i in getDays" :key="i" :value="i">
                    {{ i }}
                  </option>
                </select>
              </div>

              <div class="custom-select">
                <i class="fas fa-chevron-up" style="top: 9px"></i>
                <i class="fas fa-chevron-down" style="bottom: 7px"></i>
                <select required v-model="selected_month">
                  <option value="Mes" disabled selected>Mes</option>
                  <option
                    v-for="(month, index) in months"
                    :key="index"
                    :value="index"
                  >
                    {{ month }}
                  </option>
                </select>
              </div>

              <div class="custom-select" style="margin: 0">
                <i class="fas fa-chevron-up" style="top: 9px"></i>
                <i class="fas fa-chevron-down" style="bottom: 7px"></i>
                <select required v-model="selected_year">
                  <option value="0" disabled selected>Año</option>
                  <option v-for="(year, i) in getYears" :key="i" :value="year">
                    {{ year }}
                  </option>
                </select>
              </div>
            </div>

            <div class="style-check mb-3">
              <input
                id="check"
                type="checkbox"
                @click="acceptTerms = !acceptTerms"
                v-model="acceptTerms"
              />
              <span class="checkmark"></span>
              <label
                @click="openModalTerms"
                class="c-label ml-0 cursor-pointer text-blue-500 underline"
              >
                Términos y condiciones
              </label>
            </div>

            <div class="text-center my-4">
              <g-recaptcha
                :data-sitekey="sitekey"
                :data-validate="validate"
                :data-callback="callback"
                data-language="es-419"
                data-size
                data-btn-class="w-100"
              >
                <span v-if="!loginButton">
                  <button type="submit" class="btn-register orangeH my-4">
                    Enviar
                  </button>
                </span>
                <span v-else>
                  <button
                    class="my-4 btn-register orangeH"
                    style="width: 95px"
                    disabled
                  >
                    <div class="row">
                      &nbsp;&nbsp;
                      <half-circle-spinner
                        :animation-duration="600"
                        :size="17"
                        color="#ffffff"
                        style="margin-left: 25%; padding-top: 2px"
                      />&nbsp;
                    </div>
                  </button>
                </span>
              </g-recaptcha>

              <div class="separator"></div>
            </div>
          </form>
          <p class="text-center">
            ¿Ya tienes cuenta?
            <span style="color: #446daf; cursor: pointer" @click="Login"
              >Ingresar</span
            >
          </p>
        </div>
      </div>
    </div>
    <ModalTerms
      iconClose
      v-if="termsModal"
      :title="legalCondition.title"
      :content="legalCondition.body"
      @close="termsModal = false"
    >
      <button
        @click="(acceptTerms = true), (termsModal = false)"
        class="mx-auto max-w-75 mt-4 flex justify-center text-center w-full item-button col"
        v-text="'Acepto los terminos y condiciones.'"
      />
    </ModalTerms>
  </section>
</template>
<script>
import Close from "../../../v2/src/components/icons/Close.vue";
import CustomInput from "../../../v2/src/components/CustomInput.vue";
import axios from "axios";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import toastr from "toastr";
import { HalfCircleSpinner } from "epic-spinners";
import gRecaptcha from "@finpo/vue2-recaptcha-invisible";
import moment from "moment";
import ModalTerms from "../../../v2/src/components/ModalTerms.vue";

export default {
  name: "register",
  components: {
    VuePhoneNumberInput,
    HalfCircleSpinner,
    gRecaptcha,
    CustomInput,
    Close,
    ModalTerms,
  },
  data() {
    return {
      loginButton: false,
      months: [
        "Ene",
        "Feb",
        "Mar",
        "Abr",
        "May",
        "Jun",
        "Jul",
        "Ago",
        "Sep",
        "Oct",
        "Nov",
        "Dic",
      ],
      selected_month: "Mes",
      selected_day: "0",
      selected_year: "0",
      user: {
        name: "",
        lname: "",
        email: null,
        password: null,
        movil: "",
      },
      pass: "password",
      result: "",
      privacy: "",
      defaultCountry: "EC",
      countriesList: [
        "EC",
        "VE",
        "BR",
        "AR",
        "CL",
        "COL",
        "ES",
        "PT",
        "MX",
        "CO",
        "US",
        "PE",
      ],
      translations: {
        countrySelectorLabel: "Código",
        countrySelectorError: "Choisir un pays",
        phoneNumberLabel: "Numero de teléfono",
        example: "Exemple :",
      },
      proyect: process.env.VUE_APP_PROYECT_ID,
      serverErrors: "",
      url: window.location.origin,
      sitekey: process.env.VUE_APP_RECAPTCHA,
      termsModal: false,
      acceptTerms: false,
      legalCondition: {},
    };
  },
  mounted() {
    this.getTerms();
  },
  computed: {
    getDays() {
      const dateValue = moment()
        .year(this.selected_year)
        .month(this.selected_month);
      let days = [];
      for (let i = 1; i <= dateValue.daysInMonth(); i++) {
        days.push(i);
      }
      return days;
    },
    getYears() {
      let year = moment();
      let years = [];
      years.push(year.get("year"));
      for (let i = 0; i < 70; i++) {
        year.subtract(1, "years");
        years.push(year.get("year"));
      }

      return years;
    },
  },
  methods: {
    route() {
      this.$router.push({ name: "Home" });
    },
    Login() {
      this.$router.push({ name: "Login" });
    },
    validate() {
      // validate your form , if you don't have validate prop , default validate pass .
      return true;
    },
    callback(token) {
      if (token) {
        // google recaptcha token , then you can pass to backend with your form data .
        this.registerNewUser();
      } else if (!this.acceptTerms) {
        toastr.warning("Terminos y condiciones es requerido");
      } else {
        // if you use data-size show reCAPTCHA , maybe you will get empty token.
        toastr.error("Por favor, verifique que no es un robot");
      }
    },
    onUpdate(payload) {
      this.result = payload.formatInternational;
    },
    registerNewUser: function () {
      if (!this.validateForm()) return;

      var url = "/api/v1/register";
      this.loginButton = true;

      axios
        .post(url, {
          email: this.user.email,
          password: this.user.password,
          name: this.user.name,
          lname: this.user.lname,
          movil: this.result,
          proyect: this.proyect,
          url: window.location.origin,
          privacy: this.privacy,
          birth_date:
            this.selected_year +
            "-" +
            this.selected_month +
            "-" +
            this.selected_day,
          user_agent: navigator.userAgent,
        })
        .then(() => {
          toastr.success("Usuario registrado correctamente!");
          this.loginButton = false;
          this.user.email = "";
          this.user.password = "";
          this.user.name = "";
          this.user.lname = "";
          this.user.movil = "";
          this.proyect = "";
          this.privacy = "";
          this.$router.push("/auth/login");
        })
        .catch((error) => {
          this.serverErrors = error.response.data.errors;
          toastr.error("Verifique los datos!");
        });
    },

    async getTerms() {
      const projectId = process.env.VUE_APP_PROYECT_ID
      let response = await axios.get(`/api/v1/legal-document/${process.env.VUE_APP_LEGAL_VERSION}?proyect_id=${projectId}`);
      this.legalCondition = response.data.data;
    },

    validateForm() {
      if (this.$refs.name.validate()) {
        return false;
      }

      if (this.$refs.lname.validate()) {
        return false;
      }

      if (this.$refs.email.validate()) {
        return false;
      }

      if (this.$refs.password.validate()) {
        return false;
      }

      return true;
    },
    openModalTerms() {
      this.termsModal = !this.termsModal;
    },
  },
};
</script>

<style scoped>
::v-deep .outside-badge {
  display: flex !important;
  justify-content: center !important;
}
.w-100 {
  width: 100%;
  display: inline-block;
  align-items: center;
  justify-content: center;
}
section {
  background-image: url(/image/resource/11_fondo_png.jpg);
  background-size: cover;
  background-position: center;
}

.go-back {
  position: relative;
  color: #fff;
  cursor: pointer;
  margin-right: 10px;
  margin-top: 10px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.go-back > svg {
  margin-top: 7px;
  margin-left: 7px;
}

.input-group {
  border-radius: 0 !important;
  background-color: #fff;
}

::v-deep .vue-phone-number-input .select-country-container {
  border-right: 0.5px solid #a7a7a7 !important;
}

::v-deep .country-selector.has-value .field-input {
  border: none !important;
  outline: none !important;
  height: 44px;
  border-radius: 0;
}

::v-deep .field.vue-input-ui .field-input:not(.textarea) {
  border: none !important;
  outline: none !important;
  height: 51px;
  border-radius: 0;
}

::v-deep .field.vue-input-ui.field-input {
  border-color: transparent !important;
  border: none !important;
  float: right;
  height: 51px;
  border-radius: 0;
}

::v-deep .field.vue-input-ui.is-focused .field-input {
  border-color: transparent !important;
  border: none !important;
  float: right;
  height: 51px;
  border-radius: 0;
}

::v-deep .vue-phone-number-input .input-phone-number input {
  margin-left: initial !important;
}

.custom-select {
  border: 0.5px solid #a7a7a7;
  position: relative;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: calc(33.3% - 20px);
  padding: 0px;
  margin-right: 20px;
  border-radius: 0 !important;
}

.custom-select select {
  background-color: inherit;
  border: none;
  padding: 5px 30px 5px 10px;
  margin: 0;
  outline: none;
  width: 100%;
  -moz-appearance: none; /* Firefox */
  -webkit-appearance: none; /* Safari and Chrome */
  appearance: none;
}

.custom-select i {
  display: block;
  color: #446daf;
  font-size: 12px;
  position: absolute;
  right: 8px;
}

::v-deep input {
  outline: none;
}

input[type="number"] {
  width: 80px;
  text-align: left;
  padding: 0 5px;
  height: 40px;
  display: inline-block;
  box-sizing: border-box;
}

.logo {
  width: 114px;
  height: 38px;
  background-size: contain;
  background-image: url(/image/brand/logo.png);
  margin: 0 auto;
  margin-top: 14px;
  background-repeat: no-repeat;
}

.btn-register {
  background: transparent linear-gradient(180deg, #f1946d 0%, #de337a 100%) 0%
    0% no-repeat padding-box;
  box-shadow: 0px 5px 6px #00000029;
  border-radius: 50px;
  opacity: 1;
  color: #ffffff;
  font-size: 23px;
  width: 80%;
  height: 52px;
  max-width: 284px;
  outline: none;
}

.input-group-alternative {
  box-shadow: none !important;
  border: 0.5px solid #a7a7a7;
}

.input-group-prepend {
  margin-right: 0 !important;
}

.separator {
  position: relative;
  height: 1px;
  width: 90%;
  margin: 0 auto;
  background-color: #707070;
  opacity: 0.6;
  margin-top: 15px;
  margin-bottom: 15px;
}

.date-input {
  position: relative;
  width: 70px;
  display: inline-block;
  margin-right: 19px;
}

label > i {
  cursor: pointer;
}
</style>
